import Image from "next/image"
import styles from "./forestry.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import NewiconA from "../../assets/images/header/pdf-download1.png";
// import Webbanner from "../../assets/images/Delhi/Forestry-Optional-Delhi-Web-Banner.jpg";
// import Mobbanner from "../../assets/images/Delhi/Forestry-Optional-Delhi-Mobile-Banner.jpg";
import Link from "next/link";
import Head from "next/head";

const Forestry_Geology_Optional_Programme = () => {

    const feestructure3 =[
        // {optional: "Forestry",mode: "Regular(Offline & Online)", start: "15 th Sep 2025",fee:(<><div>₹22,500(Old students)</div> <div>₹23,000 (New students)</div></>),
        //   cont3:(<Link href=""  className={`${styles.paybill}`}> 
        //         <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Update Soon</Link>),
        //     pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
        //             <button className={`${styles.normalbutton1} btn btn-danger`}>
        //               Pay Now
        //             </button>
        //         </a>)
        //     },

        //     {optional: "Geology",mode: "Regular(Offline & Online)", start: "18th Oct  2025",fee:(<><div>₹22,500(Old students)</div> <div>₹23,000 (New students)</div></>),
        //   cont3:(<Link href="https://www.shankariasacademy.com/pdf/forestry-geology-optional-programme/GEOLOGY- Session-Plan-2025.pdf" target="blank"  className={`${styles.paybill}`}> 
        //         <Image src={NewiconA} alt="download icon"  className={`${styles.downloadicon}`}/>Click Here</Link>),
        //     pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noopener noreferrer">
        //             <button className={`${styles.normalbutton1} btn btn-danger`}>
        //               Pay Now
        //             </button>
        //         </a>)
        //     }
    ];

    return (
        <>

            <Head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title>Forestry & Geology Optional Programme | Shankar IAS Academy</title>
                <meta name="title" content="Forestry & Geology Optional Programme | Shankar IAS Academy" />
                <meta name="description" content="Enroll in our Forestry & Geology Optional Programme for UPSC. Master key concepts, ace exams, and pave your way to success. Join now!" />
                <link rel="canonical" href=" https://www.shankariasacademy.com/forestry-admission/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Forestry & Geology Optional Programme | Shankar IAS Academy" />
                <meta property="og:description" content="Enroll in our Forestry & Geology Optional Programme for UPSC. Master key concepts, ace exams, and pave your way to success. Join now!" />
                <meta property="og:url" content=" https://www.shankariasacademy.com/forestry-admission/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>

        <Navbar title="upsc" />
       
            <div className="container">
                <div className="row">
                <div className="col pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>Forestry  & Geology  Optional Programme </h1>
                </div>
                </div>
                
            {/* <div className="row">
                        <div className="col pt-2 mb-3 d-none d-md-block">
                            <Image src={Webbanner} alt="Forestry Optional Programme banner" title="Admission open for Forestry Optional Programme" className="img-fluid w-100" />
                        </div>
                </div>

                <div className="row  d-block d-md-none">
                    <div className="col pt-2 mb-3">
                        <Image src={Mobbanner} alt="Forestry Optional Programme banner" title="Admission open for Forestry Optional Programme" className="img-fluid w-100" />
                    </div>
                </div> */}

                    
                    {/* <div className="row pt-2">
                    <div className="col-md-9 col-12">
                        <h2 className={`${styles.sectiontitle} mb-0`}>Admission open for Forestry  Optional Programme</h2>
                    </div>
                    </div> */}
                </div>

         {/* <div className="container">
            <div className="row pt-md-4 pt-3">
                <div className="col">
                <p className={`${styles.sectionsubtitle} mb-2`}>Forestry Optional</p>
                </div>
            </div>
        </div>

        {/* table 1*/}


    <section  id="courseandfees">
        <div className="container pt-xl-4" >
            <div className="row">
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#072817" }}>Optional</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#389d03" }}>Batch</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#072817" }}>Starts on</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#389d03" }}>Fee</div>
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#072817" }}>Schedule</div> 
                <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#389d03" }}>Admission</div>
                <hr/>
            </div>
                        
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Optional</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.optional}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Batch</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3  pb-md-3`}>{item.mode}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.start}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-3`}>{item.fee}</div>
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-2`}>{item.cont3}</div> 
                    <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Admission</div>
                        <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
                {item.pay}
                </div>
                <hr/>
                </div>
            ))} 
        
        </div>
    </section>

                

   
    <div className="container">
    <div className="row pt-md-4 pt-3">
        <div className="col">
            <p className={`${styles.sectionsubtitle} mb-2 mb-md-3`}>Overview</p>
        </div>
    </div>
    <div className="row">
        <div className="col">
            <p className={`${styles.acheiverrank} mb-0`}>Aspiring to get into the prestigious IFS services? Shankar IAS Academy is your go-to IFS coaching centre for top-notch Indian Forest Service coaching in Chennai . The IFS Coaching centre in Chennai  offers forestry optional coaching and geology optional coaching for IFS aspirants. The IFS Coaching Centre offers optional test series for forestry, agriculture, and mathematics. Students can also choose from Forestry Crash course or Forestry Optional Classes as per their learning needs.</p>
        </div>
    </div>
    </div>

    <div className="container">
    <div className="row pt-md-4 pt-3">
        <div className="col">
            <p className={`${styles.sectionsubtitle} mb-2 mb-md-3`}>IFS Coaching</p>
            <p className={`${styles.sectionsubtitle} mb-2 mb-md-3`}>5 Reasons Why We are the Best Indian Forest Service Coaching Centre in Chennai</p>
        </div>
    </div>
    <div className="row">
        <div className="col">
        <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Consistent Results: &nbsp;</span><span className={`${styles.acheiverrank}`}> With close to 2 decades of providing meticulous and focused IAS, IFS, and UPSC coaching, Shankar IAS Academy has an unbeatable track record of top results in all these exams. More than 1000 of our students have been chosen for IAS, IPS, and other elite service sectors.</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Interactive Learning: &nbsp;</span><span className={`${styles.acheiverrank}`}> All our courses have been designed to include active student-achiever interaction. Aspirants are in constant touch with successful and serving IAS, IFS, and IPS officers who have passed out from our academy.</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Free Interview Guidance: &nbsp;</span><span className={`${styles.acheiverrank}`}> We offer free coaching for personality tests and mock interviews.</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Online Classes: &nbsp;</span><span className={`${styles.acheiverrank}`}> We are the first online coaching centre that offers 2-way LIVE communication</span>
                    </p>
                </div>
            </li>

            <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                <div className="d-inline">
                    <p className={`${styles.ullispan} d-inline`}>
                    <span className={`${styles.acheivername}`}>Mentorship Program: &nbsp;</span><span className={`${styles.acheiverrank}`}> All our students are offered 360° mentoring by expert faculty to shape their perspectives and opinions.</span>
                    </p>
                </div>
            </li>
            
        </ul>
        <p className={`${styles.acheiverrank} mb-0`}><b>Enroll with the best IFS Coaching in Chennai for resounding success in the IFS exams.</b></p> 
        </div>
    </div>
    </div>
    <Footer />                      
        </>
    )
  } 
export default Forestry_Geology_Optional_Programme